

export async function convert_grade_list(props) {
    const array = props['grade']
    const gradeList = props['gradeList']

    const new_array = []
    for(let i=0; i<array.length; i++) {
        const g = array[i]
        const c = await gradeList.find(x => x['Mcode'].trim() === g)
        if(c) {
            new_array.push({
                'name': c['McodeName'],
                'value': c['Mcode'].trim(),
                'sort': c['Sort']
            })
        }
    }

    new_array.sort((a, b) => a['sort'] - b['sort'])

    return new_array
}